export default "__VITE_ASSET__DWRXnt$i__"